import { showSuccess } from "actions/notification";
import { getAll, saveAll } from "api/subscription";

import Translate from "utils/translate";

const { t } = new Translate("notifications");

export const SUBSCRIPTIONS_GET = "SUBSCRIPTIONS_GET";
export const SUBSCRIPTIONS_UPDATE = "SUBSCRIPTIONS_UPDATE";

export const getSubscriptions = () => (dispatch) =>
  dispatch({
    type: SUBSCRIPTIONS_GET,
    payload: getAll(),
  });

export const updateSubscriptions =
  (unsubscribeDeals, assetDigest, dealDigest, portfolioDeal) => (dispatch) =>
    dispatch({
      type: SUBSCRIPTIONS_UPDATE,
      payload: saveAll(unsubscribeDeals, assetDigest, dealDigest, portfolioDeal),
    }).then(() =>
      dispatch(
        showSuccess(t("subscriptions.update.success.title"), t("subscriptions.update.success.body"))
      )
    );
